module.exports = __webpack_public_path__ + "img/emptycamfeed.4567a47f.svg";